module.exports = __webpack_public_path__ + "static/media/clinique_saint_antoine.f8abdd04.jpg";